
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePolicyAcquisitionTypes } from "@/hooks/usePolicyAcquisitionTypes";

interface PolicyAcquisitionFieldProps {
  value: string;
  onValueChange: (value: string) => void;
}

export const PolicyAcquisitionField = ({
  value,
  onValueChange,
}: PolicyAcquisitionFieldProps) => {
  const { data: acquisitionTypes, isLoading } = usePolicyAcquisitionTypes();

  return (
    <div className="space-y-2">
      <Label htmlFor="policyAcquisition">Policy Acquisition Type</Label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger id="policyAcquisition" className="w-full h-14">
          <SelectValue placeholder="Select acquisition type" />
        </SelectTrigger>
        <SelectContent>
          {!isLoading && acquisitionTypes?.map((type) => (
            <SelectItem key={type.id} value={type.name}>
              {type.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
